import img_download from "assets/img/download.svg";
import img_loading from "assets/img/loading.svg";
import axios from "axios";

import { MenuItemButton } from "components/menu/MenuItemButton";
import { useDownloadAssignmentArchive } from "hooks/useDownloadAssignmentArchive";
import { getAuthTokenFromLocalStorage } from "service/utils";

const downloadNew = async(assignmentId) => {
  const qPath = String(process.env.REACT_APP_BACKEND2_HOST) + 
      `/assignments/${assignmentId}`
  
  await axios.get(`${qPath}/downloadlink`, {
    headers: {
      authorization: `Bearer ${getAuthTokenFromLocalStorage()}`,
    }
  }).then(resp => {
    window.open(`${qPath}/archive?code=${resp.data.code}`, '_blank');
  }).catch(err => {
    alert("Ошибка при скачивании архива: " + err.message);
  })
}

export const MenuItemButtonDownloadNew = ({ assignmentId }) => {
  const { isPending, download } = useDownloadAssignmentArchive();
  return (
    <MenuItemButton
      onClick={() => downloadNew(assignmentId)}
      disabled={isPending}
      title={!isPending ? "Скачать все файлы (тест)" : "Загрузка..."}
      iconSrc={!isPending ? img_download : img_loading}
    />
  );
};


